import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const SitemapSection = styled.section`
  padding: 100px 0;
  background-color: #f9f9f9;
  
  h1 {
    margin-bottom: 40px;
    font-weight: 700;
    color: #333;
    
    span {
      color: #2e7d32;
    }
  }
  
  h2 {
    font-size: 1.5rem;
    color: #2e7d32;
    margin-bottom: 20px;
    font-weight: 600;
    position: relative;
    padding-bottom: 15px;
    
    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 50px;
      height: 2px;
      background-color: #ff9800;
    }
  }
  
  ul {
    list-style: none;
    padding: 0;
    margin-bottom: 30px;
    
    li {
      margin-bottom: 10px;
      
      a {
        color: #555;
        text-decoration: none;
        transition: color 0.3s ease;
        display: inline-block;
        
        &:hover {
          color: #2e7d32;
        }
        
        &:before {
          content: '→';
          margin-right: 8px;
          color: #ff9800;
        }
      }
    }
  }
`;

const Sitemap = () => {
  useEffect(() => {
    document.title = 'Sitemap | Bering Solutions';
  }, []);
  
  return (
    <>
      
      <SitemapSection>
        <Container>
          <h1>Site<span>map</span></h1>
          <p className="mb-5">
            Navigate our website easily with the links below. This sitemap provides links to all the main pages
            of the Bering Solutions website.
          </p>
          
          <Row>
            <Col lg={4} md={6}>
              <div className="sitemap-group">
                <h2>Main Pages</h2>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/how-it-works">How It Works</Link></li>
                  <li><Link to="/contact">Contact Us</Link></li>
                </ul>
              </div>
            </Col>
            
            <Col lg={4} md={6}>
              <div className="sitemap-group">
                <h2>Resources</h2>
                <ul>
                  <li><Link to="/faq">Frequently Asked Questions</Link></li>
                  <li><Link to="/get-offer">Get Cash Offer</Link></li>
                </ul>
              </div>
            </Col>
            
            <Col lg={4} md={6}>
              <div className="sitemap-group">
                <h2>Legal</h2>
                <ul>
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
                  <li><Link to="/sitemap">Sitemap</Link></li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </SitemapSection>
    </>
  );
};

export default Sitemap;
